import styled from '@emotion/styled';

export const SkeletonWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  svg {
    width: 100%;
    height: 2rem;
    max-height: 2rem;
    clipPath {
      rect {
        x: 0;
        width: 100%;
      }
    }
  }
`;
